import { useState } from "react";
import emailjs from "@emailjs/browser";
import './scss/_bestilltid.css';
import './scss/_kontaktoss.css';

export default function KontaktOss() {

    const [popup, setPopup] = useState<{ type: "success" | "error" | null }>({ type: null });


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const form = e.currentTarget;

        try {
            await emailjs.sendForm(
                "service_footaura",      // заміни
                "template_d1ygki1",     // заміни
                form,
                "O1vYQF94FhWixLrK1"       // заміни
            );

            setPopup({ type: "success" });
            form.reset();
        } catch (error) {
            console.error("Send error:", error);
            setPopup({ type: "error" });
        }
    };


    return (
        <>
        <section id="kontakt" className="py-16 text-center">
            <div className="cs-container">
                <div className="cs-content">
                    <h2 className="text-3xl font-bold mb-8 cs-title">Kontakt meg</h2>
                    <p className="cs-text">
                        Jeg tar vare på helsen til føttene dine
                    </p>
                    <ul className="cs-ul">
                        <li className="cs-li">
                            <picture className="cs-icon-wrapper">
                                <img aria-hidden="true"
                                     src="../phone.svg"
                                     alt="phone icon" className="cs-icon" width="40" height="40" decoding="async"/>
                            </picture>
                            <div className="cs-flex-group">
                                <span className="cs-header">Telefonnummer</span>
                                <a href="tel:+47 97273344
                        " className="cs-link">+47 97273344
                                </a>
                            </div>
                        </li>
                        <li className="cs-li">
                            <picture className="cs-icon-wrapper">
                                <img aria-hidden="true"
                                     src="../mail.svg"
                                     alt="address icon" className="cs-icon" width="40" height="40" decoding="async"/>
                            </picture>
                            <div className="cs-flex-group">
                                <span className="cs-header">E-mail</span>
                                <a href="mailto:post@footaura.no" className="cs-link">post@footaura.no</a>
                            </div>
                        </li>
                        <li className="cs-li">
                            <picture className="cs-icon-wrapper">
                                <img aria-hidden="true"
                                     src="../klokke.svg"
                                     alt="address icon" className="cs-icon" width="40" height="40" decoding="async"/>
                            </picture>
                            <div className="cs-flex-group">
                                <span className="cs-header">Åpningstider</span>
                                <p>Mandag - Lørdag: Åpnistider er flexsible og etter avtale</p>
                                <p>Søndag: fri</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <form className="cs-form" onSubmit={handleSubmit} id="cs-form-1388" name="Contact Form" method="post">
                    <label className="cs-label">
                        Navn
                        <input className="cs-input" required type="text" id="name-1388" name="name" placeholder="Navn"/>
                    </label>
                    <label className="cs-label cs-email">
                        Email
                        <input className="cs-input" required type="email" id="email-1388" name="mail"
                               placeholder="Email"/>
                    </label>
                    <label className="cs-label cs-phone">
                        Telefon nummer
                        <input className="cs-input" required type="number" id="phone-1388" name="phone"
                               placeholder="Telefon nummer"/>
                    </label>
                    <label className="cs-label">
                        Melding ditt
                            <textarea className="cs-input cs-textarea" required name="melding" id="message-1388"
                                      placeholder="Skrive melding..."></textarea>
                    </label>
                    <button type="submit" className="main-button">Send melding</button>
                </form>
            </div>
        </section>

    {/* POPUP */}
    {popup.type && (
        <div className="popup-overlay">
            <div className="popup-window">
                {popup.type === "success" && (
                    <p>Takk for meldingen, vi vil kontakte deg så snart som mulig.</p>
                )}
                {popup.type === "error" && (
                    <p>Feil! Meldingen ble ikke sendt.</p>
                )}
                <button onClick={() => setPopup({ type: null })}>OK</button>
            </div>
        </div>
    )}
   </>
);
}